import { ITickerEntityData } from '@Interfaces/CommonInterfaces'

export const calcCurrentPrice = (ticker: ITickerEntityData, tradeActionType: 'buy' | 'sell'): number => {
  let price = 1
  if (ticker) {
    const { bid, ask } = ticker
    price = tradeActionType === 'buy' ? bid : ask
  }
  return price
}

export const calcMargin = (size: number, entryPrice: number, leverage: number): string => {
  return (size * entryPrice / leverage).toFixed(2);
};

export const calcPnL = (size: number, entryPrice: number, currentPrice: number, actionType: 'buy' | 'sell'): string => {
  const multiplier = actionType === 'buy' ? 1 : -1
  const pnl = (currentPrice - entryPrice) * size * multiplier;
  return pnl.toFixed(2)
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).replace(/,/, '');
};